import Helper from "../common/Helper";
import {ajaxRequest} from "../common/Ajax";


function popupCreateUpdateFleetVehicle(rowData = {}, confirmBtnText) {

    const is_edit = rowData?.id;
    let popupTitle = 'Adaugă';
    let initValues = {}
    let is_expirable = true;

    if (is_edit) {
        popupTitle = 'Editează'
        initValues = {
            type_id: rowData?.type_id,
            vehicle_id: rowData?.vehicle_id,
            comment_id: rowData?.comment_id,
            comment_text: rowData?.comment_text,
            service_date: rowData?.service_date,
            service_km: rowData?.service_km,
            expires_date: rowData?.expires_date,
            expires_km: rowData?.expires_km
        }

        is_expirable = ESR.Helper.getFleetServiceTypeById(rowData?.type_id)?.is_expirable === '1';
    }


    let fields = {};

    if (ESR?.car) {
        fields.vehicle_id = {
            input: {
                type: 'hidden',
                value: ESR?.car.id
            }
        }
    } else {
        fields.vehicle_id = {
            label: {text: 'Vehicul'},
            input: {
                type: 'select',
                value: initValues?.vehicle_id ?? '',
                options: ESR.fleet_vehicles.map(item => ({
                    value: item.id,
                    label: item.name + (item.plate_number ? `- ${item.plate_number}` : '')
                })),
                placeholder: 'Selectează vehicul'
            },
            field: {class: 'col-span-2'}
        }
    }

    if (is_edit) {
        fields.type_id = {
            input: {
                type: 'hidden',
                value: initValues?.type_id ?? '',
            }
        }
    } else {
        fields.type_id = {
            label: {},
            input: {
                type: 'select',
                value: initValues?.type_id ?? '',
                options: Object.values(ESR.fleet_services).map(item => ({
                    value: item.id,
                    label: item.name
                })),
                placeholder: 'Selectează serviciu'
            },
            field: {class: 'col-span-2'}
        }
    }

    fields = {
        ...fields,
        'service_date': {
            label: {text: 'Data deservirii'},
            input: {
                type: 'text',
                placeholder: ESR.Helper.YmdToDmy(new Date().toDateString()) ?? '',
            },
            field: {class: 'form-control form-control-date'}
        },
        'service_km': {
            label: {text: 'KM deservirii'},
            input: {
                type: 'number',
                value: initValues?.service_km ?? '',
            }
        },

        'expires_date': is_expirable ? {
            label: {text: 'Data Expirării'},
            input: {
                type: 'text',
                placeholder: ESR.Helper.YmdToDmy(new Date(new Date().setFullYear(new Date().getFullYear() + 1))) ?? ''
            },
            field: {class: 'form-control form-control-date field-expires_date'}
        } : {},
        'expires_km': is_expirable ? {
            label: {text: 'KM Expirării'},
            input: {
                type: 'number',
                value: initValues?.expires_km ?? '',
            },
            field: {class: 'form-control form-control-date field-expires_km'}
        } : {},
        'comment_id': {
            input: {
                type: 'hidden',
                value: initValues?.comment_id ?? '',
            }
        },
        'comment_text': {
            label: {text: 'Comentariu'},
            input: {
                type: 'textarea',
                value: initValues?.comment_text ?? '',
                class: 'textarea input-bordered',
                rows: 2
            },
            field: {class: 'col-span-2'}
        }
    };

    const popupContent = $(`<div class="esr-popup-fields grid grid-cols-2 gap-4"></div>`);

    ESR.View.appendFields(popupContent, fields);


    //append from fields

    ESR.Popup.fire({
        title: popupTitle,
        html: popupContent,
        showCloseButton: true,
        confirmButtonText: confirmBtnText,
        cancelButtonText: ESR.lang.close,
        showLoaderOnConfirm: true,
        didOpen: () => {

            const serviceDateValue = initValues?.service_date ? ESR.Helper.YmdToDmy(initValues.service_date) : ''
            const expiresDateValue = initValues?.expires_date ? ESR.Helper.YmdToDmy(initValues.expires_date) : ''

            const fieldExpires = $('.field-expires_date, .field-expires_km')
            const inputExpires = fieldExpires.find('input')

            $('#sw-input-service_date').attr('value', serviceDateValue).datepicker({
                language: 'ro',
                todayBtn: true,
                autoclose: true,
                endDate: new Date(),
                format: 'dd mm yyyy'
            })

            $('#sw-input-expires_date').attr('value', expiresDateValue).datepicker({
                language: 'ro',
                todayBtn: true,
                autoclose: true,
                format: 'dd mm yyyy'
            })

            if (ESR?.car === undefined) {
                $('#sw-input-vehicle_id').select2({dropdownParent: $('.swal2-container')});
            }

            if (!is_edit) {
                $('#sw-input-type_id').select2({dropdownParent: $('.swal2-container')});
            }

            $('#sw-input-type_id').on('change', function () {
                const type_id = $(this).val();

                const is_expirable = ESR.Helper.getFleetServiceTypeById(type_id)?.is_expirable === '1';

                if (is_expirable) {
                    fieldExpires.show();
                } else {
                    fieldExpires.hide();
                    inputExpires.each( function(){  $(this).val('') });
                }
            });

        },
        preConfirm: async () => {
            let data = ESR.View.getFieldsValues(fields);
            data.id = rowData?.id ?? 0;
            data.service_date = Helper.dmyToYmd(data.service_date)
            data.expires_date = Helper.dmyToYmd(data.expires_date)


            if (!data?.service_date.length) {
                Swal.showValidationMessage('Completează cîmpul data deservirii');
                popupContent.find('#sw-input-service_date').focus();
                return;
            }

            if (data.service_date.length && data.expires_date.length) {
                const date_service = new Date(data.service_date);
                const date_expires = new Date(data.expires_date);

                if (date_expires < date_service) {
                    Swal.showValidationMessage('Data expirării nu poate fi mai mică decît data deservirii');
                    return;
                }
            }


            return await ajaxRequest({action: "esr_update_fleet_service", data});
        },
        allowOutsideClick: () => !Swal.isLoading()
    });
}

export default function tableVehicleServices(HelperTable) {

    const selectorTable = '#table-vehicle-services';
    const elTable = $(selectorTable)

    if (!elTable?.length) {
        return;
    }

    const canCreate = Helper.userCan('create_fleet_vehicle_service')
    const canEdit = Helper.userCan('edit_fleet_vehicle_service')
    const canDelete = Helper.userCan('delete_fleet_vehicle_service')


    const columns = [
        {label: 'ID', data: 'id', orderable: true},
        {data: 'type_id', label: 'Denumire', orderable: true},
        {data: 'service_date', label: 'Deservit la data'},
        {data: 'expires_date', label: 'Expiră la data'},
        {data: 'service_km', label: 'Deservit la km'},
        {data: 'expires_km', label: 'Expiră la km'},
        {data: 'author_id',  label: 'Autor', visible: false},
        {data: 'created_at',  label: 'Creat La'},
        {data: 'comment_text', label: 'Comentariu', visible: false},
    ];

    const columnDefs = [
        {
            targets: 0, // ID
            width: '60px',
            className: 'text-center'
        },
        {
            targets: 1, // Name
            width: '200px',
            render: function (data, type, row) {
                const serviceType = ESR.Helper.getFleetServiceTypeById(row.type_id);
                return serviceType ? serviceType.name : row.type_id;
            }
        },
        {
            targets: 2,  //service_date
            width: '100px'
        },
        {
            targets: 3, //expires_date
            width: '100px'
        },
        {
            targets: 4, //service_km
            width: '100px'
        },
        {
            targets: 5, //expires_km
            width: '100px'
        },
        {
            targets: 6, //author_id
            width: '100px',
            render: function (data, type, row) {
                return  Helper.getUserNameById(row.author_id) ?? row.author_id;
            }
        },
        {
            targets: 7, //created_at
            width: '150px'
        },
        {
            targets: 8, //comment
            width: '300px'
        }
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    elTable.append(myTableHeader)

    const car = ESR?.car;
    let printTitle = car ? [car.name, car.plate_number, car.vin].filter(Boolean).join(' | ') : '';

    let toolbarButtons = [HelperTable.btnColvis(), HelperTable.btnDownloads(printTitle)];

    if (canCreate) {
        function callbackBtnAdd(e) {
            e.preventDefault();
            popupCreateUpdateFleetVehicle({}, ESR.lang.update);
        }

        toolbarButtons.push(HelperTable.btnAdd(e => callbackBtnAdd(e)))
    }

    if (canEdit) {
        function callbackBtnEdit(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            popupCreateUpdateFleetVehicle(elRow.data(), ESR.lang.update);
        }

        toolbarButtons.push(HelperTable.btnEdit(e => callbackBtnEdit(e)))
    }

    if (canDelete) {
        function callbackBtnRemove(e) {
            e.preventDefault();

            const elRow = table.row('.selected');

            if (!elRow.node()) {
                // "No row selected."
                return;
            }

            const rowData = elRow.data();

            ESR.Popup.delete({
                title: rowData.title,
                html: `<p>Toată <b>datele</b> și <b>istoria</b> vor fi șterse definitiv, doriți să ștergeți ?</p`,
                action: 'esr_remove_fleet_service',
                id: rowData.id
            })
        }

        toolbarButtons.push(HelperTable.btnRemove(e => callbackBtnRemove(e)))
    }

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        columnDefs: columnDefs,
        stateSave: true,
        displayLength: 25,
        order: [
            [2, 'dsc']
        ],
        processing: false,
        serverSide: false,
        info: false,
        layout: {

            topStart: {
                buttons: toolbarButtons,
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
            bottom: 'paging',
            bottomStart: null,
            bottomEnd: null
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
        },
    });

    if (canCreate) {
        const btnRowEdit = table.buttons().container().find('.btn-row-edit')
        const btnRowRemove = table.buttons().container().find('.btn-row-remove')
        $('body').on('click', (e) => {
            HelperTable.onSelectRow(e, table, btnRowEdit, btnRowRemove)
        });
    }

}